export default __webpack_public_path__ + "static/media/Cocktail.37504af1.jpg";